import React, { useEffect } from "react";
// import introJs from "intro.js";
import "../../css/Tutorial.css"
import { useNavigate } from "react-router-dom";
import introJs from "intro.js";

const DashboardTutorial = (props) => 
  {
  
    const navigate = useNavigate();

  useEffect(() => {
    const intro = introJs();

    intro.setOptions({
      steps: [
        {
          element: ".step1",
          intro: "📖 از اینجا میتونی اولین مقاله رو سفارش بدی و مقاله های تولید شده رو ببینی و مدیریت کنی!",
        },
        {
          element: ".step2",
          intro: "📋 از اینجا میتونی پلن ماهیانه خودت رو برای تولید مقاله انتخاب کنی!!",
        },
        {
          element: ".step3",
          intro: "🖼️ از اینجا هم میتونی تصویر واترمارکی که میخوای روی عکسهای مقاله گذاشته بشه رو انتخاب کنی!",
        },
      ],
      showBullets: false,
      showProgress: true,
      exitOnOverlayClick: false,
      disableInteraction: false,
      nextLabel: "بعدی",
      prevLabel: "قبلی",
      doneLabel: " گرفتم 🎉",
      disableInteraction: true
    });

    // Navigate to another page when the tutorial ends
    intro.oncomplete(async () =>  await props.SaveDashboardTutorialSeen(true));
    intro.onexit(async () => await props.SaveDashboardTutorialSeen(true));
    

    intro.start();
  }, [navigate]);


};

export default DashboardTutorial;
